export default __webpack_public_path__ + "static/media/world_map_image.fbce5a68.png";